import React from 'react';
import { colors, grid, SvgIcon } from '@noths/polaris-client-ribbons-design-system';

import { Button } from 'src/components/atoms/Button';
import { getIconPath } from 'src/utils';
import * as styles from './styles';

export interface Props {
  className?: string;
  controls: string;
  isExpanded: boolean;
  toggleExpanded: () => void;
}

const CHEVRON_DOWN = getIconPath('icons-16-chevron-down.svg');
const CHEVRON_UP = getIconPath('icons-16-chevron-up.svg');

export const ExpandableToggleButton = ({
  className,
  controls,
  isExpanded,
  toggleExpanded,
}: Props) => (
  <div>
    <Button
      className={className}
      aria-controls={controls}
      aria-expanded={isExpanded}
      css={styles.expandingButton}
      onClick={toggleExpanded}
    >
      <SvgIcon
        height={16}
        width={16}
        color={colors.brandBluePrimary}
        src={isExpanded ? CHEVRON_UP : CHEVRON_DOWN}
      />
      &nbsp; Show {isExpanded ? 'less' : 'more'}
    </Button>
    <div css={[grid, styles.expandingButtonDividerContainer]}>
      <hr css={styles.expandingButtonDivider} />
    </div>
  </div>
);
